"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
function default_1({ status, confirm, isCloneRoom, }) {
    if (status === 404) {
        if (isCloneRoom) {
            confirm({
                description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('최초 1회만 복제할 수 있어요.'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('새로운 복제 요청이 확인되었어요.'), (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('판매내역을 확인해 주세요')}:)`] })),
                cancellationButtonProps: { style: { display: 'none' } },
            });
        }
        else {
            confirm({
                description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('앗, 작가님이 삭제한 임시저장이에요.'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('새롭게 작성해주세요.')] })),
                cancellationButtonProps: { style: { display: 'none' } },
            })
                .then(functions_1.goToCreateRoom)
                .catch(functions_1.goToCreateRoom);
        }
    }
    else {
        confirm({
            description: (0, errors_1.commonErrorMsg)(status),
            cancellationButtonProps: { style: { display: 'none' } },
        });
    }
}
exports.default = default_1;
